<form [formGroup]='ResetPasswordForm'>
  <div class="card card-login">
    <div class="card-content">

      <div class="row">
        <div class="container-fluid">
          <div class="login-header text-center">
            <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
            <h3>Reset password</h3>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11" [ngClass]="{'has-error': (ResetPasswordForm.get('oldPassword')?.touched || ResetPasswordForm.get('oldPassword')?.dirty)
          && !ResetPasswordForm.get('oldPassword')?.valid }">
          <span class="input-group-addon addon-left-top">
            <i class="material-icons">lock</i>
          </span>
          <div class="form-group label-floating is-empty">
            <label class="control-label">Old password</label>
            <input type="password" formControlName="oldPassword" class="form-control" (input)="checkEquality()">
            <span class="help-block" *ngIf="(ResetPasswordForm.get('oldPassword')?.touched ||
              ResetPasswordForm.get('oldPassword')?.dirty)  && ResetPasswordForm.get('oldPassword')?.errors">
              <span *ngIf="ResetPasswordForm.get('oldPassword')?.errors.required" class="text-danger">
                Please enter the old password.
              </span>
            </span>
          </div>
        </div>

        <div formGroupName="passwordGroup" [ngClass]="{'has-error': ResetPasswordForm.get('passwordGroup')?.errors }">
          <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11" [ngClass]="{'has-error':
            (ResetPasswordForm.get('passwordGroup.newPassword')?.touched
            || ResetPasswordForm.get('passwordGroup.newPassword')?.dirty)
            && !ResetPasswordForm.get('passwordGroup.newPassword')?.valid }">
            <span class="input-group-addon addon-left-top">
              <i class="material-icons">lock</i>
            </span>
            <div class="form-group label-floating is-empty">
              <label class="control-label">New password</label>
              <input [type]="passwordInput" formControlName="newPassword" [popover]="popTemplate"
                triggers="input:focusout" placement="bottom" #pop="bs-popover" class="form-control"
                (input)="checkPasswordStrength($event.target.value)">
              <ng-template #popTemplate>
                <div class="row" style="padding-left: 10px; padding-right: 10px;">
                  <label>Password policy</label><br>
                </div>
                <div *ngIf="securityPolicyForReset == undefined" class="row"
                  style="padding-left: 10px; padding-right: 10px;">
                  <label>No Password policy are loaded for this user</label><br>
                </div>

                <ng-container *ngIf="securityPolicyForReset != undefined">

                  <div class="row" style="padding-left: 10px; padding-right: 10px;">
                    <div>
                      <i *ngIf="usernameContains" class="material-icons" style="color:  green;">done</i>
                      <i *ngIf="!usernameContains" class="material-icons" style="color: lightgrey;">clear</i>Should be
                      different from the username
                    </div>
                  </div>

                  <div *ngIf="securityPolicyForReset.security.usernameRestriction && securityPolicyForReset.security.usernameCharacterNo > 0" class="row"
                    style="padding-left: 10px; padding-right: 10px;">
                    <div>
                      <i *ngIf="usernameChar" class="material-icons" style="color:  green;">done</i>
                      <i *ngIf="!usernameChar" class="material-icons" style="color: lightgrey;">clear</i>
                      Must not contain more than {{securityPolicyForReset.security.usernameCharacterNo}} characters from
                      the user's name
                    </div>
                  </div>
                  <div class="row" style="padding-left: 10px; padding-right: 10px;">
                    <div>
                      <i *ngIf="this.passwordCharNumber == securityPolicyForReset.security.passwordMinCharacterNo || this.passwordCharNumber > securityPolicyForReset.security.passwordMinCharacterNo"
                        class="material-icons" style="color:  green;">done</i>
                      <i *ngIf="this.passwordCharNumber < securityPolicyForReset.security.passwordMinCharacterNo"
                        class="material-icons" style="color: lightgrey;">clear</i>
                      Minimum
                      {{securityPolicyForReset.security.passwordMinCharacterNo}} characters
                    </div>
                  </div>

                  <!-- new password policies -->
                  <div *ngIf="securityPolicyForReset.security.passwordSpaceRestriction " class="row"
                    style="padding-left: 10px; padding-right: 10px;">
                    <div>
                      <i *ngIf="!passwordContainsSpace" class="material-icons" style="color:  green;">done</i>
                      <i *ngIf="passwordContainsSpace" class="material-icons" style="color: lightgrey;">clear</i>
                      Must not contain spaces
                    </div>
                  </div>

                  <div class="row" *ngIf="securityPolicyForReset.security.passwordUsersNameRestriction" style="padding-left: 10px; padding-right: 10px;">
                    <div>
                      <i *ngIf="usernameChar" class="material-icons" style="color:  green;">done</i>
                      <i *ngIf="!usernameChar" class="material-icons" style="color: lightgrey;">clear</i>
                      Must not contains user’s name
                    </div>
                  </div>
                  <!-- end of new password policies -->

                  <div class="row" style="padding-left: 10px; padding-right: 10px;"
                    *ngIf="securityPolicyForReset.security.passwordUpperCaseRestriction">
                    <i *ngIf="upperCaseNo == securityPolicyForReset.security?.passwordUpperCaseNo || upperCaseNo > securityPolicyForReset.security?.passwordUpperCaseNo"
                      class="material-icons" style="color: green;">done</i>
                    <i *ngIf="upperCaseNo < securityPolicyForReset.security?.passwordUpperCaseNo" class="material-icons"
                      style="color: lightgrey;">clear</i>
                    At least {{securityPolicyForReset.security?.passwordUpperCaseNo}} upper
                    case letter <br>
                  </div>
                  <div class="row" *ngIf="securityPolicyForReset.security.passwordLowerCaseRestriction"
                    style="padding-left: 10px; padding-right: 10px;">
                    <i *ngIf="lowerCaseNo == securityPolicyForReset.security?.passwordLowerCaseNo || lowerCaseNo > securityPolicyForReset.security?.passwordLowerCaseNo"
                      class="material-icons" style="color: green;">done</i>
                    <i *ngIf="lowerCaseNo < securityPolicyForReset.security?.passwordLowerCaseNo" class="material-icons"
                      style="color: lightgrey;">clear</i>
                    At least {{securityPolicyForReset.security?.passwordLowerCaseNo}}
                    lower case letter <br>
                  </div>
                  <div class="row" style="padding-left: 10px; padding-right: 10px;"
                    *ngIf="securityPolicyForReset.security.passwordNumberRestriction">
                    <div *ngIf="securityPolicyForReset.security?.passwordNumberNo == 1">
                      <i *ngIf="containsNo == securityPolicyForReset.security?.passwordNumberNo || containsNo > securityPolicyForReset.security?.passwordNumberNo"
                        class="material-icons" style="color: green;">done</i>
                      <i *ngIf="containsNo < securityPolicyForReset.security?.passwordNumberNo" class="material-icons"
                        style="color: lightgray;">clear</i>
                      Must contain number
                    </div>
                    <div *ngIf="securityPolicyForReset.security?.passwordNumberNo > 1">
                      <i *ngIf="containsNo == securityPolicyForReset.security?.passwordNumberNo || containsNo > securityPolicyForReset.security?.passwordNumberNo"
                        class="material-icons" style="color: green;">done</i>
                      <i *ngIf="containsNo < securityPolicyForReset.security?.passwordNumberNo" class="material-icons"
                        style="color: lightgray;">clear</i>
                      Must contain at least {{securityPolicyForReset.security?.passwordNumberNo}} numbers
                    </div>
                  </div>

                  <div class="row" style="padding-left: 10px; padding-right: 10px;"
                    *ngIf="securityPolicyForReset.security.passwordSpecialCharRestriction">
                    <div *ngIf="securityPolicyForReset.security?.passwordSpecialCharNo == 1">
                      <i *ngIf="specialCharNo == securityPolicyForReset.security?.passwordSpecialCharNo || specialCharNo > securityPolicyForReset.security?.passwordSpecialCharNo"
                        class="material-icons" style="color: green;">done</i>
                      <i *ngIf="specialCharNo < securityPolicyForReset.security?.passwordSpecialCharNo"
                        class="material-icons" style="color: lightgray;">clear</i>
                      Must contain special character
                    </div>
                    <div *ngIf="securityPolicyForReset.security?.passwordSpecialCharNo > 1">
                      <i *ngIf="specialCharNo == securityPolicyForReset.security?.passwordSpecialCharNo! || specialCharNo > securityPolicyForReset.security?.passwordSpecialCharNo"
                        class="material-icons" style="color: green;">done</i>
                      <i *ngIf="specialCharNo < securityPolicyForReset.security?.passwordSpecialCharNo"
                        class="material-icons" style="color: lightgray;">clear</i>
                      Must contain at least {{securityPolicyForReset.security?.passwordSpecialCharNo}} special character
                    </div>
                  </div>

                  <div class="row" style="padding-left: 10px; padding-right: 10px;"
                    *ngIf="securityPolicyForReset.security.customRules?.length > 0">
                    <div>
                      <i *ngIf="customRulesValidation == true" class="material-icons" style="color: green;">done</i>
                      <i *ngIf="customRulesValidation == false" class="material-icons"
                        style="color: lightgray;">clear</i>
                      Must match regular expression of custom rules
                    </div>
                  </div>
                </ng-container>
              </ng-template>
              <span *ngIf="passwordInput === 'password'" title="Show password"
                class="input-group-addon addon-right text-gray cursor-pointer" (click)="passwordModeOn(true, true)">
                <i class="mdi mdi-eye"></i>
              </span>
              <span *ngIf="passwordInput === 'text'" title="Hide password"
                class="input-group-addon addon-right text-gray cursor-pointer" (click)="passwordModeOn(false, true)">
                <i class="mdi mdi-eye-off"></i>
              </span>
              <span class="help-block pull-left" *ngIf="
                (ResetPasswordForm.get('passwordGroup.newPassword')?.touched ||
                ResetPasswordForm.get('passwordGroup.newPassword')?.dirty) &&
                ResetPasswordForm.get('passwordGroup.newPassword')?.errors">
                <span *ngIf="ResetPasswordForm.get('passwordGroup.newPassword')?.errors.required" class="text-danger">
                  Please enter the new password.
                </span>
              </span>
            </div>
          </div>

          <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11" [ngClass]="{'has-error':
            (ResetPasswordForm.get('passwordGroup.confirmNewPassword')?.touched
            || ResetPasswordForm.get('passwordGroup.confirmNewPassword')?.dirty)
            && !ResetPasswordForm.get('passwordGroup.confirmNewPassword')?.valid }">
            <span class="input-group-addon addon-left-top">
              <i class="material-icons">lock</i>
            </span>
            <div class="form-group label-floating is-empty">
              <label class="control-label">Confirm new password</label>
              <input [type]="confirmPasswordInput" formControlName="confirmNewPassword" class="form-control">
              <span *ngIf="confirmPasswordInput === 'password'" title="Show password"
                class="input-group-addon addon-right text-gray cursor-pointer" (click)="passwordModeOn(true, false)">
                <i class="mdi mdi-eye"></i>
              </span>
              <span *ngIf="confirmPasswordInput === 'text'" title="Hide password"
                class="input-group-addon addon-right text-gray cursor-pointer" (click)="passwordModeOn(false, false)">
                <i class="mdi mdi-eye-off"></i>
              </span>
              <span class="help-block pull-left" *ngIf="(ResetPasswordForm.get('passwordGroup.confirmNewPassword')?.touched ||
                ResetPasswordForm.get('passwordGroup.confirmNewPassword')?.dirty) &&
                (ResetPasswordForm.get('passwordGroup.confirmNewPassword')?.errors ||
                ResetPasswordForm.get('passwordGroup')?.errors) ">
                <span *ngIf="ResetPasswordForm.get('passwordGroup.confirmNewPassword')?.errors?.required"
                  class="text-danger">
                  Please confirm the confirm password.
                </span>
                <span *ngIf="ResetPasswordForm.get('passwordGroup').errors?.match" class="text-danger">
                  The confirmation does not match the password.
                </span>
              </span>
            </div>
          </div>
        </div>

        <div class="input-group col-md-11 col-lg-11 col-sm-11 col-xs-11" *ngIf="checkNewPassword">
          <span class="input-group-addon">
            <i class="material-icons text-danger"> warning </i>
          </span>
          <div class="form-group label-floating is-empty">
            <span *ngIf="ResetPasswordForm.get('checkNewPassword')?.errors.required" class="text-danger">
              Your new password cannot be the same as your old password
            </span>
          </div>
        </div>
      </div><!--row end-->

      <div class="text-center">
        <button type="submit" [disabled]="!ResetPasswordForm.valid || !passwordValidation" class="btn btn-primary"
          (click)="onSubmitForm()"
          [ngStyle]="{'background-color': this.sharedService.ButtonColor.value, 'color':  this.sharedService.TextButtonColor.value}">Reset
          password</button>
      </div>
    </div><!--card-content end-->

    <div class="footer text-center">
      <p class="small">
        <a (click)="chooseOtherAcount()" style="cursor: pointer">
          <i class="material-icons">account_box</i> Sign in with a different account</a>
      </p>
    </div>
  </div>
  <!----card end------>
</form>
